import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSerializedSchedule } from 'api';
import { fetchJSON } from 'api/fetch';
import { captureException } from 'fe-core/util/errorTracking';

import { getCurrentUserIsManagerial } from 'selectors/session';

import clearScheduleLegacy from 'features/scheduleBuilder/ScheduleBuilderView/actions/clearScheduleLegacy';
import Schedule from 'features/scheduleBuilder/ScheduleBuilderView/resources/Schedule';
import { loadJobTotals } from 'features/scheduleBuilder/ScheduleBuilderView/slice';

import { getTimeDifference } from 'util/dateTime';

import { selectSliceAttribute } from '../helpers';
import { selectJobIds } from '../jobs/slice';

export const fetchSchedule = createAsyncThunk(
  'scheduleBuilderSchedule/fetch',
  async ({ startDate, endDate }: { startDate: string; endDate: string }) => {
    try {
      const response = await fetchJSON(
        fetchSerializedSchedule({
          startDate,
          endDate,
        })
      );
      return response;
    } catch (error) {
      captureException(error);
    }
  }
);

export const reloadSchedule = createAsyncThunk(
  'scheduleBuilder/reloadSchedule',
  async (
    {
      startDate,
      endDate,
      force = true,
    }: { startDate: string; endDate: string; force?: boolean },
    { dispatch, getState }
  ) => {
    const state = getState();
    const currentScheduleStartDate = selectSliceAttribute({
      state,
      attribute: 'startDate',
      sliceName: 'schedule',
    });
    const currentScheduleEndDate = selectSliceAttribute({
      state,
      attribute: 'endDate',
      sliceName: 'schedule',
    });

    // date range is outside of the current one
    if (
      force ||
      getTimeDifference(currentScheduleStartDate, startDate, 'days') < 0 ||
      getTimeDifference(currentScheduleEndDate, endDate, 'days') > 0
    ) {
      dispatch(clearScheduleLegacy());
      const isManager = getCurrentUserIsManagerial(state);
      /* FE-CORE is necessary here to refetch the schedule */
      let res: any;

      return dispatch(
        Schedule.fetch({
          payload: {
            start_date: startDate,
            end_date: endDate,
          },
          id: '',
          beforeDigestCallback: () => {},
        })
      )
        .then((response: any) => {
          // If request to fetch schedule fails - go back to the previous date range
          res = response;
          if (response?.error) {
            dispatch(Schedule.clearAllEntities());
            return;
          }
          if (isManager) {
            dispatch(
              loadJobTotals(
                response?.payload?.data?.relationships?.jobs?.data?.map(
                  (j: any) => j.id
                ) ||
                  selectJobIds(state) ||
                  []
              )
            );
          }
        })
        .catch((error: unknown) => {
          console.error(error);
          captureException(error, {
            extra: {
              payload: JSON.stringify(res),
            },
          });
        });
    }

    return Promise.resolve();
  }
);
